import { type Route } from '@angular/router';
import { newsCategoryRoutes } from './category/news-category.routes';
import { CategoryFormServiceToken } from '../../common/category-details/abstract-category-form-service.token';
import { NewsCategoryFormService } from './service/news-category-form.service';
import { dirtyCheckCanDeactivateGuard } from '../../common/dirty-check/dirty-check';
import { hasStringPathParamCanActivateGuard } from '@pct/ng-core-router';

export const newsRoutes: Route[] = [
  {
    path: '',
    loadComponent: () => import('./list/news-list.component'),
    pathMatch: 'full',
  },
  {
    path: 'category',
    children: newsCategoryRoutes,
    title: 'PAGES.NEWS.CATEGORY.BREADCRUMB.LIST',
    providers: [{ provide: CategoryFormServiceToken, useClass: NewsCategoryFormService }],
  },
  {
    path: 'new',
    loadComponent: () => import('./details/news-details.component'),
    title: 'PAGES.NEWS.CATEGORY.BREADCRUMB.NEW',
    canDeactivate: [dirtyCheckCanDeactivateGuard('HasDirtyCheck')],
  },
  {
    path: ':id',
    loadComponent: () => import('./details/news-details.component'),
    title: 'PAGES.NEWS.CATEGORY.BREADCRUMB.EDIT',
    canActivate: [hasStringPathParamCanActivateGuard('id')],
    canDeactivate: [dirtyCheckCanDeactivateGuard('HasDirtyCheck')],
  },
  {
    path: '**',
    redirectTo: '',
  },
];
